import React, { useState } from 'react';

import HeroSection from '../../components/HeroSection/HeroSection';

import ezkoop from '../../assets/images/ezkoop.png';
import kaskoop from '../../assets/images/kaskoop.png';
import zeytinKoop from '../../assets/images/zeytin-koop.png';
import cooperation from '../../assets/images/cooperation.jpg';

import './cooperation.sass';

const list = [
  {
    title: 'EZKOOP',
    image: ezkoop,
    desc:
      'Serüvenine 2012 yılında başlayan Esnaf Zanaatkarlar ve Üreticiler Pazarlama Kooperatifi (EZKOOP), tarımsal ürünlerin ve el işlerinin kooperatifleşme ve kümelenme yolu ile pazarlanması ve yerel ürünlerin hem Kıbrıs Türk toplumuna hem de turizme kazandırılması hedefiyle, KTEZO tarafından sürdürülen çabaların bir sonucu olarak 2017’de kurulmuştur. <br/> <br/> Avrupa Birliği’nin teknik ve finansal desteği ile yürütülmüş olan TAPS programı* çerçevesinde ürün deseninin belirlenmesi ve üretim potansiyelinin ortaya çıkarılmasına yönelik fizibilite çalışmaları KTEZO işbirliğinde gerçekleştirilmiş ve ilk etapta zeytin ve üzüm potansiyeli yüksek ürünler olarak belirlenmiştir. Bu çalışmaları takiben eşzamanlı olarak Karpaz yöresinden Büyükkonuk Zeytin Üreticileri Tarım kooperatifi Limited (Büyükkonuk Zeytin-Koop) ile Mehmetçik köyü merkezli Karpaz, Üzüm, Şarap, Alkollü İçki Üretim ve Pazarlama Kooperatifi (Kas Koop) LTD kurulmuş, diğer bir taraftan da Lefke, Serdarlı, Girne, Yeni Boğaziçi ve Mağusa’daki yerel ürün üreticileri ile temasa geçilmiş ve kooperatifleşme ile kümelenme çalışmaları yürütülmüştür. <br/> <br/> EZKOOP tüm bu üreticilerin temsilcilerinin yönetim kurulunda yer aldığı bir şemsiye kooperatifi şeklinde örgütlenmiş ve tüm bu yapılanmalara teknik destek veren bir yapılanmadır.<br/> <br/> * Avrupa Birliği tarafından finanse edilen ve Diadikasia S.A. Konsorsiyumu tarafından yürütülen Yerel Paydaşların (İş Destekleme Kurumları dahil) Kapasitesinin ve Özel Sektörünün Rekabet Edebilirliğinin Geliştirilmesi Teknik Destek Programı, 2016-2018 yılları arasında gerçekleşmiştir.'
  },
  {
    title: 'Büyükkonuk \n Zeytin-Koop',
    image: zeytinKoop,
    desc:
      '2017 yılında Kaskoop ve EZKOOP ile birlikte kurulan Büyükkonuk Zeytin Koop, ağırlıkla zeytin ve zeytin ürünleri ile uğraşan bir üretim kooperatifidir. <br/> br/> İskele İlçesine bağlı 14 köyden 150’yi aşkın üyeye sahiptir. Kooperatifin TAŞ DEĞİRMEN adında Naturel sızma zeytinyağı markası iç piyasada tüketilmenin yanı sıra Avustralya ve İngiltere’ye de satışı yapılmaktadır. <br/> <br/> Üye üreticiler ilaçlama ve budama eğitimleri yanında zeytinlerini düşük asitli olarak çıkarmak amaçlı değirmene nasıl getirecekleri konusunda da eğitimler almışlardır. Böylece zeytinler değirmene uygun durum ve zamanda getirilmekte, değirmende gıda mühendisi kontrolünde soğuk sıkım aracılığı ile yağa dönüştürülmekte, anında asitlik oranları ölçülüp 0.8’in üstünde orana sahip yağlar kabul edilmemektedir. Ardından çelik silolarda 45 gün bekletilen zeytinyağları, uluslararası akreditasyonu olan laboratuvarlarda test edildikten sonra iç piyasa ve ihracat için koyu cam şişelerde şişelenip alıcılara ulaştırılmaktadır.<br/> <br/> 2018 yılındaki hasatta 0.76 asiditede üretilen zeytinyağı, 2019 hasatında 0.63 asitlik oranına düşürülerek 0.8’lik natürel sızma eşik değerinin de altına düşmüştür. Gerek yağın kalitesi ve gerekse de uygun şişeleme sayesinde oluşan nitelikli son ürün dış satımı da olası kılmıştır. <br/> <br/> Kooperatif, yağın dışında çakıstes ve siyah zeytin üretimine de başlamış ve bunlar piyasaya sunulmuştur. 2020 Kasım ayında da Taş Değirmen markalı zeytinyağı sabunu üretilip piyasaya sunulmuştur. <br/> <br/> 2019 yılından beri yürütülen “Zeytin Ürünlerinin Üretimi ve Markalaşması” Projesi ile Avrupa Birliği’nin Rekabet Edebilir İşletmeler, Kümeler ve İş Destek Kurumlarına Yönelik Hibe Programı kapsamında hibe almaya hak kazamıştır. Proje kapsamında, gerek fidanlık kurulumu, gerekse de hasat ve paketlemeyi kolaylaştıracak ünitelerle, girdi ve paketleme maliyetlerini aşağı çekecek çalışmalar sürdürülmektedir. '
  },
  {
    title: 'KAS-KOOP',
    image: kaskoop,
    desc:
      'Karpaz, Üzüm, Şarap, Alkollü İçki Üretim ve Pazarlama Kooperatifi LTD, EZKOOP ve Büyükkonuk Zeytin-Koop ile beraber kurulan ve merkezine üzüm ve üzüm ürünleri üretimini alan Mehmetçik merkezli kooperatiftir. Üzüm ürünlerinin uygun standartlarda ve marka olarak üretilmesi yönünde çalışmalar yapmaktadırlar. Ekim 2020 tarihinde yerel bir üretici ile işbirliğinde kooperatif üyelerinin üzümlerinden ALAF marka zivaniya üretilerek piyasaya sunulmuştur.'
  }
];

const ListItems = ({ list }) => {
  const [expanded, setExpanded] = useState();

  const handleClick = item => {
    setExpanded(expanded === item ? null : item);
  };

  return (
    <>
      <div className="list">
        {list.map((item, index) => (
          <div
            className="list-item help-section-content"
            onClick={() => handleClick(item.desc)}
            key={index}
            data-active={index === expanded}
          >
            <img src={item.image} alt={item.title} />
            <span className="home-help-header">{item.title}</span>
          </div>
        ))}
      </div>
      <div className="desc" data-visible={expanded ? true : false}>
        <div className="desc-item">
          <span
            dangerouslySetInnerHTML={{
              __html: expanded
            }}
            className="cooperation-content-text last-text"
          ></span>
        </div>
      </div>
    </>
  );
};

const Cooperation = () => {
  return (
    <div>
      <HeroSection text="Ağ Kurma" src={cooperation} />
      <div className="cooperation">
        <p className="cooperation-subtitle">Ağ Kurma Olanakları</p>
        <span className="cooperation-content-text">
          Mikro ve küçük işletmelerin gelişmesinde diğer işletmelerle ve farklı
          kurumlarla ağlar ve işbirlikleri kurmanın önemi büyüktür.
          <br /> <br />
          Doğru ağlar ve işbirlikleri mikro ve küçük işletmeler için yeni iş ve
          finansman fırsatları yaratabilir. Bunun yanında, diğer başarılı
          işletmelerin bilgilerinden yararlanılarak işletmeyi daha ileriye
          taşıyabilecek stratejiler geliştirilebilir. İşletmeler, yeni iş
          eğilimlerinden ve teknolojilerden daha hızlı haberdar hale gelerek
          rakiplerinin önüne geçebilirler.
          <br /> <br />
          İleride gerçekleşecek faaliyetlerimiz websitemizden ve sosyal medya
          kanallarımızdan duyurulacaktır.
        </span>

        <span className="cooperation-second-title cooperation-description">
          Kooperatifçilik ve Kümelenme Faaliyetleri
        </span>

        <span className="cooperation-content-text">
          Kıbrıs Türk Esnaf ve Zanaatkârlar Odası, Kıbrıslı Türk zanaatkâr ve
          esnafın temsilcisi olarak yerel kalkınmada, kırsal ürünlerin işlenerek
          kaliteli ve dengeli bir fiyat politikası ile sunulmasının, özellikle
          kırsal kalkınma stratejilerinin ayrılmaz bir parçası olduğunun
          farkındadır.
          <br /> <br />
          Bunların yanında sertifikalı ve kaliteli ürünlerin dış pazarlara da
          ulaşma şansı olduğunun bilinci ile hem işlenmiş gıda alanında hem de
          geleneksel elişlerinin üretilip pazarlanmasında katkıda bulunma
          hedefindedir.
          <br /> <br />
          Kümelenerek (kooperatif ve üretici birlikler temelli) çalışmanın hem
          ölçek ekonomisi hem de maliyet düşürücü etkisi ile ekonomik kalkınmaya
          katkı sunacağı aşikârdır. Bu amaçla KTEZO birçok kooperatif ve
          kümelenme çalışmasının içinde yer almıştır.
        </span>

        <ListItems list={list} />
      </div>
    </div>
  );
};

export default Cooperation;
